import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const PaymentSuccessIcon: React.FC<SvgProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="118"
        height="121"
        viewBox="0 0 118 121"
        fill="none"
    >
        <g clip-path="url(#clip0_284_2951)">
            <path
                d="M44.2238 87.9414H10.27"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M55.8467 74.7285H10.27"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M37.9256 61.5078H10.27"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M25.7479 48.2891H9.5498"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M55.8466 87.9414H50.3369"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M55.8466 99.3535H43.7759"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M35.784 99.3535H10.27"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M0.973633 118.958V27.5879"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M65.1139 119.074L57.1025 113.246L49.091 119.074L41.0698 113.246L33.0584 119.074L25.0372 113.246L17.016 119.074L8.99482 113.246L0.973633 119.074"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M65.1138 78.8496V118.959"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M0.973633 27.5977L8.98509 33.4261L17.0063 27.5977L25.0177 33.4261L33.0292 27.5977L37.9256 31.153"
                stroke="#042933"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M79.842 73.4378C99.7608 73.4378 115.908 57.3244 115.908 37.4474C115.908 17.5705 99.7608 1.45703 79.842 1.45703C59.9232 1.45703 43.7759 17.5705 43.7759 37.4474C43.7759 57.3244 59.9232 73.4378 79.842 73.4378Z"
                stroke="#65AE51"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M66.4282 35.0682L76.922 48.289L93.2661 24.3828"
                stroke="#65AE51"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_284_2951">
                <rect width="117.378" height="120.046" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default PaymentSuccessIcon;
